import { MenuItem } from './MenuItem'
import { MenuInnerWithSub } from './MenuInnerWithSub'
import { MegaMenu } from './MegaMenu'
import { useIntl } from 'react-intl'
import { MenuDownloadItem } from './MenuDownloadItem'
import { useAuth } from '../../../../app/modules/auth/core/Auth'
import { KTIcon } from '../../../helpers'
import { useEffect } from 'react'

export function MenuInner() {
  const intl = useIntl()
  const { auth } = useAuth()
  const isKybPending = auth?.flow === 'kyb'

  useEffect(() => {
    const menu = document.getElementById('kt_header_menu')
    if (menu) {
      menu.style.pointerEvents = isKybPending ? 'none' : ''
    }
  }, [isKybPending])

  const lockedTitle = (label: string) =>
    isKybPending ? (
      <span className='d-flex align-items-center gap-1'>
        {label}
        <KTIcon iconName='lock' className='fs-8 text-muted ms-1' />
      </span>
    ) : label

  return (
    <>
      <MenuItem title={lockedTitle(intl.formatMessage({ id: 'MENU.DASHBOARD' }))} to='/dashboard' />
      <MenuItem title={lockedTitle(intl.formatMessage({ id: 'MENU.BULK_REPORT' }))} to='/bulkreport' />
      <MenuItem title={lockedTitle(intl.formatMessage({ id: 'MENU.MY_HOPS' }))} to='/hops' />
      <MenuItem title={lockedTitle(intl.formatMessage({ id: 'MENU.HOPS_APPROVAL' }))} to='/approve-hops' />
      <MenuItem title={lockedTitle(intl.formatMessage({ id: 'MENU.REPORTS' }))} to='/report-section' />
      <MenuItem title={lockedTitle(intl.formatMessage({ id: 'MENU.TICKETS' }))} to='/support' />
      {/* <MenuItem title='Layout Builder' to='/builder' />
      <MenuInnerWithSub
        title='Crafted'
        to='/crafted'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MenuInnerWithSub
          title='Pages'
          to='/crafted/pages'
          icon='element-plus'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuInnerWithSub
            title='Profile'
            to='/crafted/pages/profile'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
            <MenuItem
              to='/crafted/pages/profile/connections'
              title='Connections'
              hasBullet={true}
            />
          </MenuInnerWithSub>
          <MenuInnerWithSub
            title='Wizards'
            to='/crafted/pages/wizards'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true} />
            <MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
          </MenuInnerWithSub>
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Accounts'
          to='/crafted/accounts'
          icon='profile-circle'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
          <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Errors'
          to='/error'
          icon='fingerprint-scanning'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/error/404' title='Error 404' hasBullet={true} />
          <MenuItem to='/error/500' title='Error 500' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Widgets'
          to='/crafted/widgets'
          icon='element-11'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
          <MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
          <MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
          <MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
          <MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
          <MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
        </MenuInnerWithSub>
      </MenuInnerWithSub>

      <MenuInnerWithSub title='Apps' to='/apps' menuPlacement='bottom-start' menuTrigger='click'>
        <MenuInnerWithSub
          title='Chat'
          to='/apps/chat'
          icon='message-text-2'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
          <MenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
          <MenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
        </MenuInnerWithSub>
        <MenuItem icon='shield-tick' to='/apps/user-management/users' title='User management' />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        isMega={true}
        title='Mega menu'
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MegaMenu />
      </MenuInnerWithSub> */}
      <MenuInnerWithSub isMega title={intl.formatMessage({ id: 'MENU.RESOURCES' })} to='/manage' menuPlacement='bottom-start' menuTrigger='click'>
        <MenuDownloadItem
          download={false}
          title={intl.formatMessage({ id: 'MENU.USER_MANUAL' })}
          href='/resources/User_Manual-Goflipo_TM_Panel.pdf'
          icon='file-down'
        />
        <MenuDownloadItem
          download={false}
          title={intl.formatMessage({ id: 'MENU.API_DOCUMENTATION' })}
          href='/resources/TM_API_Documentation.pdf'
          icon='code'
        />
        <MenuDownloadItem
          download={false}
          title={intl.formatMessage({ id: 'MENU.SMPP_GUIDELINE' })}
          href='/resources/SMPP_Guideline.pdf'
          icon='code'
        />
        <MenuItem to='/support?tab=faq' title={intl.formatMessage({ id: 'MENU.FAQ' })} icon='question' />
      </MenuInnerWithSub>
    </>
  )
}
